export default {
  // general
  report: "Report",
  report_id: "Report ID",
  report_date: "Report Date",
  reference: "Reference",

  // status
  pass: "Pass",
  fail: "Fail",
  repaired: "Repaired",
  validated: "Validated",
  success: "Success",

  // actions
  create_new_report: "Create new report",
  edit_report_information: "Edit Report Information",
  duplicate_row: "Duplicate row",
  view_technical_sheet: "View technical sheets",
  scroll_back: "Scroll back",

  // views
  client_view: "Client View",
  executive_view: "Executive View",

  // templates & problems
  report_columns: "Report Columns",
  report_template: "Report Templates",
  problem_categories: "Problem Categories",
  problem_departments: "Problem Departments",

  // defects
  defect: "Defect",
  defect_category: "Defect Category",

  // search
  search_report: "Search by ID, serial number or description",
  no_report_found: "No report found.",
  clear_filters: "Clear filters",

  // messages
  report_saving: "Report is saving...",
  exit_page_confirmation:
    "Are you sure you want to exit the page? There are pending saves...",
  report_deleted_successfully: "Report deleted successfully"
};
